import { useMemo } from 'react'
import * as React from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import LineTabs from '@app.components/tabs/LineTabs/LineTabs'
import ChannelAdBannerBox from '@app.feature/channel/component/ChannelAdBannerBox'
import ChannelFooter from '@app.feature/channel/component/ChannelFooter'
import ChannelNavbarDesktop from '@app.feature/channel/component/ChannelNavbar/ChannelNavbar.desktop'
import ChannelSearchAll from './menus/ChannelSearchAll/ChannelSearchAll'
import ChannelSearchChannelList from './menus/ChannelSearchChannel/ChannelSearchChannel'
import ChannelSearchNewsList from './menus/ChannelSearchNews/ChannelSearchNewsList'

const channelSearchTabs = [
  {
    id: 0,
    name: '전체',
    size: `33%`,
    href: {
      query: {
        tab: 'all',
      },
    },
  },
  {
    id: 1,
    name: '소식',
    size: `33%`,
    href: {
      query: {
        tab: 'news',
      },
    },
  },
  {
    id: 2,
    name: '채널',
    size: `33%`,
    href: {
      query: {
        tab: 'channel',
      },
    },
  },
]

const ScreenChannelSearchDesktop: React.FC = () => {
  const router = useRouter()

  const selectedMenu = useMemo(
    () => `${router.query.tab ? router.query.tab : 'all'}`,
    [router.query],
  )
  return (
    <StyledWrapper>
      <ChannelNavbarDesktop className="nav-bar" searchBar="visible" sticky />
      <div className="channel-search-header">
        <div>
          <h1 className="channel-content csh-title">채널 검색</h1>
        </div>
      </div>
      <div className="csh-tabs">
        <div className="channel-content csh-tabs-content">
          <LineTabs
            fullWidth
            savePrevQuery
            data={channelSearchTabs}
            initialTab={channelSearchTabs[0]}
          />
        </div>
      </div>
      <div className="channel-content channel-search-content">
        <div className="lt">
          {selectedMenu === 'all' && <ChannelSearchAll />}
          {selectedMenu === 'news' && <ChannelSearchNewsList />}
          {selectedMenu === 'channel' && <ChannelSearchChannelList />}
        </div>
        <div className="rt">
          <ChannelAdBannerBox />
          <div className="footer-wrapper">
            <ChannelFooter />
          </div>
        </div>
      </div>
    </StyledWrapper>
  )
}

export default ScreenChannelSearchDesktop

const StyledWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  .nav-bar {
    z-index: 4;
  }
  .channel-content {
    max-width: 1148px;
    margin: 0 auto;
    padding: 0 24px;
    width: 100%;
  }
  .hr {
    border-bottom: 1px solid #eeeeee;
  }
  .channel-search-header {
    background-color: white;
    padding-top: 50px;
    .csh-title {
      font-size: 30px;
      font-weight: 600;
      padding-bottom: 10px;
    }
  }
  .csh-tabs {
    top: 108px;
    position: sticky;
    background-color: white;
    z-index: 1;
  }
  .csh-tabs-content {
    display: grid;
    grid-template-columns: minmax(730px, 730px) minmax(320px, 320px);
    height: 60px;
    gap: 50px;
  }
  .channel-search-content {
    display: grid;
    grid-template-columns: minmax(730px, 730px) minmax(320px, 320px);
    gap: 50px;
    & > .lt {
      margin-top: 22px;
    }
    & > .rt {
      margin-top: 68px;
      .footer-wrapper {
        margin: 20px 35px;
      }
    }
  }
`
